import React, { memo, useState } from 'react';
import { Area } from '@ant-design/plots';

// styles
import './style.scss';
import { Typography, Radio } from 'antd';

function HomeLineChart() {
  const [tab, setTab] = useState('week');
  const hours = {
    week: 12,
    month: 48,
    semester: 288,
  };

  const data = {
    week: [
      {
        Date: '2010-01',
        scales: 1998,
      },
      {
        Date: '2010-02',
        scales: 1850,
      },
      {
        Date: '2010-03',
        scales: 1720,
      },
      {
        Date: '2010-04',
        scales: 1818,
      },
      {
        Date: '2010-05',
        scales: 1920,
      },
      {
        Date: '2010-06',
        scales: 1802,
      },
      {
        Date: '2010-07',
        scales: 1945,
      },
      {
        Date: '2010-08',
        scales: 1856,
      },
      {
        Date: '2010-09',
        scales: 2107,
      },
      {
        Date: '2010-10',
        scales: 2140,
      },
      {
        Date: '2010-11',
        scales: 2311,
      },
    ],
    month: [
      {
        Date: '2011-01',
        scales: 1765,
      },
      {
        Date: '2011-02',
        scales: 1988,
      },
      {
        Date: '2011-03',
        scales: 1642,
      },
      {
        Date: '2011-04',
        scales: 1933,
      },
      {
        Date: '2011-05',
        scales: 2021,
      },
      {
        Date: '2011-06',
        scales: 1778,
      },
      {
        Date: '2011-07',
        scales: 1912,
      },
      {
        Date: '2011-08',
        scales: 2050,
      },
      {
        Date: '2011-09',
        scales: 2190,
      },
      {
        Date: '2011-10',
        scales: 2288,
      },
      {
        Date: '2011-11',
        scales: 2467,
      },
    ],
    semester: [
      {
        Date: '2012-01',
        scales: 1835,
      },
      {
        Date: '2012-02',
        scales: 1920,
      },
      {
        Date: '2012-03',
        scales: 1776,
      },
      {
        Date: '2012-04',
        scales: 2034,
      },
      {
        Date: '2012-05',
        scales: 2156,
      },
      {
        Date: '2012-06',
        scales: 1900,
      },
      {
        Date: '2012-07',
        scales: 2022,
      },
      {
        Date: '2012-08',
        scales: 2188,
      },
      {
        Date: '2012-09',
        scales: 2321,
      },
      {
        Date: '2012-10',
        scales: 2401,
      },
      {
        Date: '2012-11',
        scales: 2598,
      },
    ],
  };

  const config = {
    data: data[tab],
    xField: 'Date',
    yField: 'scales',
    xAxis: {
      range: [0, 1],
      tickCount: 5,
    },
    areaStyle: () => {
      return {
        fill: 'l(270) 0:#0D588A 1:#f59c05',
      };
    },
    line: {
      color: '#f59c05',
    },
  };

  return (
    <div className="absent-students">
      <Typography.Title level={3} className="heading-title">
        Étudiants Absents
      </Typography.Title>
      <div className="tab-container">
        <Typography.Text className="tab-container--text">
          Aujourd’hui : <span>{hours[tab]} heures</span>
        </Typography.Text>

        <Radio.Group
          options={[
            { label: 'Semaine', value: 'week' },
            { label: 'Mois', value: 'month' },
            { label: 'Semestre', value: 'semester' },
          ]}
          buttonStyle="solid"
          optionType="button"
          value={tab}
          onChange={e => setTab(e.target.value)}
          className="tab-container--tab"
        />
      </div>
      <div className="line-chart">
        <Area {...config} height={200} />
      </div>
    </div>
  );
}

HomeLineChart.defaultProps = {};
HomeLineChart.propTypes = {};

export default memo(HomeLineChart);
